import { AsyncPipe } from "@angular/common";
import { Component, EventEmitter, inject, Output } from "@angular/core";
import { CoreChip, SvsBreakpointService } from "@svs/angular";

@Component({
  selector: "app-feedback-chips",
  imports: [
    CoreChip,
    AsyncPipe,
  ],
  templateUrl: "./feedback-chips.component.html",
  styleUrl: "./feedback-chips.component.scss",
})
export class FeedbackChipsComponent {

  answers = [
    "Antwort unvollständig",
    "Antwort schwer verständlich",
    "Antwort nicht relevant für die Frage",
    "Antwort nicht richtig",
    "Frage wurde falsch verstanden",
    "Falsche Verlinkung"
  ];

  _selected: string[] = [];

  @Output() selectedChanged = new EventEmitter<string[]>();

  get selected(): string[] {
    return this._selected;
  }

  set selected(selected: string[]) {
    this._selected = selected;
    this.selectedChanged.emit(selected);
  }

  isMobile$ = inject(SvsBreakpointService).isMobile$;

  changed(answer: string, checked: boolean) {
    if(checked) {
      this.selected = [...this.selected, answer]
    } else {
      this.selected = this.selected.filter(s => s !== answer);
    }
  }
}
